import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=af820868&"
import script from "./MenuCard.vue?vue&type=script&lang=ts&"
export * from "./MenuCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports